import { api } from './api.ts';

/**
 * Starting a CABS Identity sign-in from the organizer console.
 *
 * The ceremony is begun and completed on this origin, against this origin's `/api`, and the
 * session it produces is stored by this console's own client. Nothing crosses to another surface:
 * a browser cannot read a session stored under a different origin, so a ceremony that completed
 * elsewhere would authenticate nobody here.
 *
 * There is no first-use action, and there is no endpoint behind one. Accounts are created on the
 * attendee surface alone; this console authenticates people who already hold authority in
 * GateCheckPro, and authenticating at CABS grants none.
 */
export async function startCabsSignIn(nextPath: string): Promise<void> {
  const started = await api.request<{ authorizationUrl: string }>(
    // The surface is the endpoint's, not this request's. The server reads nothing from the body
    // about which console is asking.
    '/api/v1/auth/cabs/organizer/start',
    {
      method: 'POST',
      anonymous: true,
      body: { returnTo: new URL(nextPath, window.location.origin).toString() },
    },
  );
  window.location.assign(started.authorizationUrl);
}
